// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login-form[data-v-21029cd6]{padding:2.5em;height:100%}", ""]);
// Exports
module.exports = exports;
